// extracted by mini-css-extract-plugin
export default {"footnote":"hFUCT"};